import { t } from '../lib/i18n';

/**
 * The only indeterminate state this SPA is allowed to show. Boot renders it
 * while the two boot requests are in flight and NEVER as the answer to a
 * failure -- every failure has a named screen (Blocking).
 *
 * DESIGN SPIKE: the word still renders (it is what `role="status"` announces
 * and what the DOM suites read); the ring beside it is `aria-hidden` decoration.
 */
export function Spinner() {
  return (
    <p
      className="spinner flex items-center justify-center gap-2.5 px-4 py-10 text-[0.8125rem] text-muted"
      role="status"
      aria-live="polite"
    >
      <span
        aria-hidden="true"
        className="size-4 animate-spin rounded-full border-2 border-line border-t-accent"
      />
      {t('common.loading')}
    </p>
  );
}
